<div class="mat-icon-div" [matMenuTriggerFor]="isMiniCartDisabled() ? null :  cartMenu" #menuTrigger="matMenuTrigger"
  (click)="isMiniCartDisabled() ? '' : onMenuClick()"
  (keydown.enter)="isMiniCartDisabled() ? null : onMenuClick()"
  (keydown.space)="isMiniCartDisabled() ? null : onMenuClick()">
  <mat-icon [class]="isMiniCartDisabled() ? 'count-icon-disabled' : 'count-icon'"
    [matBadge]="isMiniCartDisabled() ? '' : cartItemsCount() > maxCount ? `${maxCount}+` : cartItemsCount()"
  aria-hidden="false" [matBadgeHidden]="isMiniCartDisabled()">shopping_cart</mat-icon>
  <span [matMenuTriggerFor]="isMiniCartDisabled() ? null : cartMenu" #menuTrigger="matMenuTrigger"
    [class]="isMiniCartDisabled() ? 'cart-title-disabled' : 'cart-title-enabled'">{{titleValue() ? titleValue() :
  (pageContentLabels | contentFilter: LABELS.UNTITLED_CART)}}</span>
</div>

<mat-menu #cartMenu="matMenu" class="mini-cart-menu" yPosition="below" xPosition="after" hasBackdrop="true"
  backdropClass="menu-backdrop-blur">
  <!-- Header -->
  <!-- Cart Header -->
  <div class="menu-wrapper srp-mini-cart-header" disableRipple="true" mat-menu-item (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <div class="mini-cart-title">
      <srp-icon icon="shopping_cart"></srp-icon>
      <div class="mini-cart-title-text">
        @if(showInput()) {
          <srp-text-input class="mini-cart-input" #textInput (keydown)="getTitle($event)"
          (focusout)="focusOut()"></srp-text-input>
        } @else {
          <span>{{titleValue()}}</span>
        }
        @if (!isFrozen()) {
        <srp-icon [icon]="showInput() ? 'check' : 'edit'"
        (mousedown)="showInput() ? saveTitleValue() : setTitle()"></srp-icon>
        }
      </div>

<div class="estimate-status">

  @if (estimateId && isFrozen()) {
    <srp-icon
      icon="order_approve"
      [variant]="'symbols-outlined'"
      class="estimate-frozen">
    </srp-icon>

    <span class="estimate-frozen">
      {{(pageContentLabels | contentFilter: LABELS.ESTIMATE_FROZEN) || 'Estimate Frozen'}}
    </span>
  } @else {
    <span class="srp-cart-save">
      <srp-icon icon="save"></srp-icon>
      {{
        (pageContentLabels | contentFilter : LABELS.SAVED_AUTO_TEXT)
        || 'Saved Automatically'
      }}
    </span>
  }

</div>


  </div>

  <div class="mini-cart-close">
    <mat-icon (click)="closeCart()" (keydown.enter)="closeCart()" (keydown.space)="closeCart()" tabindex="0" aria-label="Close cart">close</mat-icon>
  </div>
</div>

<!-- Body -->
<div class="menu-wrapper srp-mini-cart-body" disableRipple="true" mat-menu-item (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
  @if(showSpinner()) {
    <div class="overlay-loader">
      <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    </div>
  }
  @if (operationGroups && operationGroups.length > 0) {
    <mat-accordion [multi]="true">
      @for (group of operationGroups; track group; let i = $index) {
        <mat-expansion-panel
          [expanded]="accordionIndexes.includes(i) === true">
          <mat-expansion-panel-header class="mini-cart-accordion-header" (click)="toggleAccordion(i)" (keydown.enter)="toggleAccordion(i)">
            <div class="accordion-header">
              <mat-panel-title>
                <div class="flex-container">
                  @if (group.operationName!='null'|| 'Unknown Operation') {
                    <p>{{ group.operationName }}</p>
                  }
                  <div class="flex-right">
                    <span class="srp-cart-vat-label">{{(pageContentLabels | contentFilter: LABELS.SUB_TOTAL)
                    || 'Sub Total Incl. VAT'}} </span>
                    <span class="srp-cart-vat-value">{{ group.subTotal }} {{currencySymbol}}</span>
                    @if (!isFrozen()) {
                    <srp-icon icon="do_not_disturb_on" variant="outlined" [matTooltip]="operationDelete"
                    (click)="onRemoveClicked(group.operationName,'operation',i,$event)" (keydown.enter)="onRemoveClicked(group.operationName,'operation',i,$event)" tabindex="0"></srp-icon>
                    }
                  </div>
                </div>
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <div class="mini-cart-accordion-body">
            <!-- Parts Table -->
            @if (group.partsLength>0) {
              <srp-table [hidePagination]="true"
                [tableKey]="'minicart-parts-' + group.operationName" [pageContent]="labels">
              </srp-table>
            }
            <!-- Labour Table -->
            @if (group.labourLength>0) {
              <srp-table [hidePagination]="true"
                [tableKey]="'minicart-labour-' + group.operationName" [pageContent]="labels">
              </srp-table>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  } @else {
    @if(cartLoaded() && !showSpinner()) {
      <div class="mini-cart-no-data-message">
        <div class="mini-cart-message-caintaner">
          <div class="mini-cart-icon">
            <srp-icon icon="shopping_cart"></srp-icon>
          </div>
          <div class="mini-cart-message-title">
            <h3>{{(pageContentLabels | contentFilter: LABELS.EMPTY_SHOPPING_CART) || 'Your shopping cart is empty!'}}
            </h3>
          </div>
          <div class="mini-cart-message-caption">
            <p>{{(pageContentLabels | contentFilter: LABELS.ADD_OPERATIONS_PARTS) || 'Add operations, parts, and labour or catalogs'}}</p>
          </div>
        </div>
      </div>
    }
  }

  <!-- Templates -->
  <ng-template #quantityTemplate let-row>
    <srp-quantity (emitValue)="getQuantityValue($event, row)" [(ngModel)]="row.quantity" [disabled]="isFrozen()"></srp-quantity>
  </ng-template>

  <ng-template #actionTemplate let-row>
    @if (!isFrozen()) {
    <srp-icon icon="do_not_disturb_on" variant="outlined" [matTooltip]="partsToolTip"
    (click)="onRemoveClicked(row, 'parts',row,$event)" (keydown.enter)="onRemoveClicked(row, 'parts',row,$event)" tabindex="0"></srp-icon>
    }
  </ng-template>

  <ng-template #priceTemplate let-row>
    <span class="row-price">{{row.totalPriceIncludingVAT}}</span>
    @if (row.discount === '-') {
      <srp-icon
        class="row-discount-empty-icon"
        [matTooltip]="(pageContentLabels | contentFilter: LABELS.DISCOUNT_NOT_APPLIED) || 'Discount not applied as it was not loaded.'"
        icon="remove"></srp-icon>
    } @else {
      <span
        class="row-discount"
        [matTooltip]="((pageContentLabels | contentFilter: LABELS.DISCOUNT_APPLIED) || '{0} Discount applied').replace('{0}', row.discount)">
        {{ ((pageContentLabels | contentFilter: LABELS.DISCOUNT_APPLIED) || '{0} Discount applied').replace('{0}', row.discount) }}
      </span>
    }
  </ng-template>

  <ng-template #actionTemplateLabour let-row>
    @if (!isFrozen()) {
    <srp-icon icon="do_not_disturb_on" variant="outlined" [matTooltip]="labourToolTip"
    (click)="onRemoveClicked(row, 'labour',row,$event)" (keydown.enter)="onRemoveClicked(row, 'labour',row,$event)" tabindex="0"></srp-icon>
    }
  </ng-template>

  <ng-template #descriptionTemplate let-row>
    <srp-caption [mainText]="row.description.mainText" [subText]="row.description.subText">
    </srp-caption>
  </ng-template>
  <ng-template #availabilityTemplate let-row>
    <srp-caption [mainText]="row.availability.mainText" [subText]="row.availability.subText">
    </srp-caption>
  </ng-template>
</div>
<!-- Footer -->
<div class="srp-mini-cart-footer" disableRipple="true" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
  <div class="srp-min-cart-total-price"><span class="srp-mini-cart-total-label">{{(pageContentLabels | contentFilter:
  LABELS.TOTAL_PRICE_INCL_VAT) || 'Total Price Incl VAT'}}</span><span class="srp-mini-cart-total-value">
{{totalPrice | number:'1.2-2'}} {{currencySymbol}}</span></div>
<div class="flex">
  <srp-button icon="mail" class="srp-cart-button" (click)="openCart()" (keydown.enter)="openCart()">
    {{ (pageContentLabels | contentFilter: LABELS.FULL_CART_VIEW) || 'Full Cart View' }}
  </srp-button>
  <div class="flex-right">
    <srp-button icon="file_copy" class="srp-cart-new-estimate" (click)="openNewEstimate()" (keydown.enter)="openNewEstimate()">
      {{ (pageContentLabels | contentFilter: LABELS.NEW_ESTIMATE) || 'New Estimate' }}
    </srp-button>
    <srp-button icon="mail" class="srp-cart-button" (click)="openOrder()" (keydown.enter)="openOrder()" [disabled]="distributorLength() == 0">
      {{ (pageContentLabels | contentFilter: LABELS.ORDER) || 'Order' }}
    </srp-button>
  </div>
</div>

</div>
</mat-menu>